export default __webpack_public_path__ + "static/media/diamond_outline.0a69be69.svg";